import './bootstrap'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

// Import CodeMirror for syntax highlighting
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/edit/closebrackets'
import 'codemirror/addon/hint/show-hint'

const container = document.getElementById('react-app')
if (container) {
    createRoot(container).render(<App />)
} else {
    console.error('No #react-app element found to bind to')
}
